import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { audioService } from '../services/audioService';


import CustomerForm from '../components/tabForms/CustomerForm';
import DemandasTable from '../components/DemandasTable';
import AudioSearchModal from '../components/AudioSearchModal';

const CustomersPage = () => {
    // Estado inicial del cliente.
    const [customer, setCustomer] = useState({
        createDate: '',
        hubspotID: '',
        Identifier: '',
        rut: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        //fechaNacimiento:'',
        fecha_nacimiento__sin_verificar_: '',
        address: '',
        country: '',
        countries: '',
        region: '',
        provincia: '',
        sucursal: '',
        categoria: '',
        tipoCliente: '',
        claveunica: '',
        Observations: '',
        pymeData: '',
        generos: '',
        estadoCivil:'',
        tiposCliente: '',
        rutPyme: '',
        nombrePyme: '',
        nivelEducacional:'',


    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [audioData, setAudioData] = useState(null);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const navigate = useNavigate();

    // Desestructurar el rut del estado


    // Estados para manejar los datos del formulario.
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [regiones, setRegiones] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [selectedProvincia, setSelectedProvincia] = useState('');
    const [comunas, setComunas] = useState([]);
    const [selectedComuna, setSelectedComuna] = useState('');
    const [sucursales, setSucursal] = useState([]);
    const [categorias, setCategoria] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState('');
    const [selectedSucursal, setSelectedSucursal] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [causas, setCausas] = useState([]);
    const [tiposCliente, setTipoCliente] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(1);
    const [selectedClave, setSelectedClave] = useState(1);
    const [clavesCliente, setClaveCliente] = useState([]);
    const [rutPyme, setRutPyme] = useState('');
    const [nombrePyme, setNombrePyme] = useState('');
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [generos, setGenero] = useState([]);
    const [estadoCiviles , setEstadoCivil] = useState([]);
    const [validacionMatrimonio , setvalidacionMatrimonio] = useState([]);

    const [loadingEstadoCivil, setLoadingEstadoCivil] = useState(false);

    const [estadoCivilList, setEstadoCivilList] = useState([]);

    const [selectedNivelEducacional,setSelectedNivelEducacion]= useState('');
    
    const [selectedGenero, setSelectedGenero] = useState('');
    const [selectedEstadoCivil , setSelectedEstadoCivil] = useState("");
    const [infoMessage, setInfoMessage] = useState(null);

    const [nivelEducacional, setNivelEducacional]= useState([]);


    const location = useLocation();
    const customerData = location.state;

    
    const maxLength = 500;
    const hubspotId = customerData?.id

    const handleAudio = (hubspotId) => {
        setIsModalOpen(true); // Mostrar el modal
        handleSearchAudio(hubspotId); // Buscar el audio
    };

    const handleSearchAudio = async () => {
        setLoading(true);
        setError(null);
        
        if (!hubspotId) { // Verifica si el hubspotId está disponible
            setError('No se encontró HubSpot ID');
            setLoading(false);
            return;
        }

        try {
            const result = await audioService.searchAudio(hubspotId);
            setAudioData(result);
        } catch (err) {
            setError('No se encontraron registros de Audio. Por favor, intente mas tarde.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    

    const handleViewDetail = (user) => {
        setSelectedUser(user);
        setIsDetailModalOpen(true);
    };
    const handleCerrar = () => {
        setIsDetailModalOpen(false);
    }



    return (
        <Container maxWidth="lg">

            <DemandasTable
                causas={causas}
                loading={loading}
                customStyles={customStyles}
                handleViewDetail={handleViewDetail}
                isDetailModalOpen={isDetailModalOpen}
                selectedUser={selectedUser}
                handleCerrar={handleCerrar}
                customerData={customerData}
            />
            <CustomerForm
                customer={customer}
                customerData={customerData}

            />

            <AudioSearchModal
                open={isModalOpen}
                onClose={handleCloseModal}
                loading={loading}
                error={error}
                audioData={audioData}
                hubspotId={customer.hubspotID} // Pasar el hubspotId como prop
                onSearchAudio={handleSearchAudio} // Función para buscar audio
            />



        </Container>


    );
};

const customStyles = {
    table: {
        style: {
            minWidth: '100%',

        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F7',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            fontSize: '12px',
            fontWeight: '600',
            color: '#86868B',
            textTransform: 'uppercase',
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            color: '#1D1D1F',
        },
    },
};
export default CustomersPage;